/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { preprocessTextForWeglotTranslation } from "i18n/textTransformations";
import { TRANSLATE_THIS_BLOCK_BY_WEGLOT } from "i18n/weglot";
import React from "react";
import { sanitizer } from "utility/sanitize";

type Props = {
  description: string;
  /** 暗い背景に載せる。本文色を白にする */
  isDarkModeEnabled?: boolean;
  /** 本文を 14px・字間 1px にする */
  isCompact?: boolean;
  isTruncatedToOneLine?: boolean;
};

/**
 * サニタイズとリンク・画像の見た目をこのコンポーネントに閉じることで、
 * 説明文を表示するページ間でリンクの見た目が分岐しないようにしている
 */
export const EventDescription: React.FC<Props> = (props) => {
  const html = preprocessTextForWeglotTranslation(props.description);

  return (
    <div
      className={TRANSLATE_THIS_BLOCK_BY_WEGLOT}
      css={[textStyle(props), contentStyle]}
      dangerouslySetInnerHTML={{ __html: sanitizer(html) }}
    />
  );
};

const LINK_COLOR = "#07ccd5";

const contentStyle = css({
  lineHeight: "1.5em",
  img: {
    maxWidth: "100%",
  },
  a: {
    color: LINK_COLOR,
    textDecoration: "underline",
  },
});

const textStyle = (props: Props) =>
  css([
    props.isDarkModeEnabled && {
      color: "#fff",
    },
    props.isCompact && {
      fontSize: "14px",
      letterSpacing: "1px",
    },
    props.isTruncatedToOneLine && {
      height: "1.5em",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  ]);
